import { render, staticRenderFns } from "./account.component.vue?vue&type=template&id=5217d71b"
import script from "./account.component.vue?vue&type=script&lang=ts"
export * from "./account.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports